module.exports = __webpack_public_path__ + "img/pharmacy.920e3212.svg";